import CancelIcon from "@mui/icons-material/Clear";
import { IconButton } from "@mui/material";
import PropTypes from "prop-types";

const CancelIconButton = (props) => {
  return (
    <IconButton size="small" className="cancel-icon-button" onMouseDown={props.onSearchCancel}>
      <CancelIcon />
    </IconButton>
  );
};

CancelIconButton.propTypes = {
  onSearchCancel: PropTypes.func.isRequired,
};

export default CancelIconButton;
